import React from 'react';
import CrmAvatar from '../../../shared/components/CrmAvatar';
import BreadcrumbChevron from '../../../shared/components/BreadcrumbChevron';
import StatusBadge from '../../../../shared/StatusBadge';
import { useMembershipShowContext } from '../../startup/MembershipShowApp';

export default function MemberHeader() {
  const {
    membership,
    membershipProductPath,
    membershipProductsPath,
    fanPath,
    settingsPath,
  } = useMembershipShowContext();

  const firstName = membership.first_name;
  const lastName = membership.last_name;
  const name = [firstName, lastName].filter(Boolean).join(' ').trim() || membership.email;
  const product = membership.membership_product;
  const memberSince = membership.created_at
    ? new Date(membership.created_at).toLocaleDateString('en-US', { year: 'numeric', month: 'short', day: 'numeric' })
    : null;

  return (
    <div className="member-header mb-4">
      <nav aria-label="breadcrumb" className="mb-3">
        <div className="d-flex align-items-center flex-wrap" style={{ gap: 4 }}>
          {settingsPath && (
            <>
              <a href={settingsPath} className="settings-breadcrumb-link">Settings</a>
              <BreadcrumbChevron />
            </>
          )}
          {membershipProductsPath && (
            <a href={membershipProductsPath} className="settings-breadcrumb-link">Memberships</a>
          )}
          {product && membershipProductPath && (
            <>
              <BreadcrumbChevron />
              <a href={membershipProductPath} className="settings-breadcrumb-link">{product.name}</a>
            </>
          )}
          <BreadcrumbChevron />
          <span className="settings-breadcrumb-current">{name}</span>
        </div>
      </nav>
      <div className="team-member-card">
        <div style={{ padding: 24 }}>
          <div className="d-flex align-items-center justify-content-between flex-wrap" style={{ gap: 16 }}>
            <div className="d-flex align-items-center" style={{ gap: 16 }}>
              <CrmAvatar firstName={firstName} lastName={lastName} name={name} />
              <div>
                <div className="d-flex align-items-center flex-wrap" style={{ gap: 8 }}>
                  <h2 className="mb-0">{name}</h2>
                  <StatusBadge status={membership.staff_status || membership.status} />
                </div>
                <div className="text-muted">{membership.email}</div>
              </div>
            </div>
            <div className="d-flex align-items-center" style={{ gap: 8 }}>
              <div className="text-right">
                {product && membershipProductPath && (
                  <div className="small">
                    <span className="text-muted">Membership:</span>{' '}
                    <a href={membershipProductPath}>{product.name}</a>
                  </div>
                )}
                {memberSince && (
                  <div className="text-muted small">Member since {memberSince}</div>
                )}
              </div>
              {fanPath && (
                <a href={fanPath} className="btn btn-setlist-secondary">
                  View Fan Profile
                </a>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

MemberHeader.propTypes = {};
